import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";
import { withPrefix } from "gatsby";

import { Layout } from "../components/common";
import { MetaData } from "../components/common/meta";
// import { createRelatedPostFeeds } from '../components/Posts'

/**
 * Single post view (/:slug)
 *
 * This file renders a single post and loads all the content.
 *
 */
class Post extends Component {
    componentDidMount() {
        // after DOM rendering, fetch anchor tag from post-body
        // and set attribute _blank for external URLs
        var anchors = document.querySelector("#post-body").getElementsByTagName("a");
        for (var i = 0; i < anchors.length; i++) {
            var myLink = anchors[i].getAttribute("href");
            let hostname = '';
            if (myLink) {
                try {
                    const url = new URL(myLink);
                    hostname = url.hostname;
                } catch (error) {
                }
                if (!hostname.includes('noissue')) {
                    anchors[i].setAttribute("target", "_blank");
                    anchors[i].setAttribute("rel", "noopener noreferrer");
                }
            }
        }
    }
    
    // Function to prepend CDN URL to image sources
    prependCdnToImages(html) {
        if (!html) {
            return html;
        }

        // RegExp to find img tags with src attributes
        const imgRegex = /<img[^>]+src="([^"]+)"[^>]*>/g;
        
        // Replace each image src with the CDN URL prepended
        return html.replace(imgRegex, (match, src) => {
            // Only process images from ghost.noissue.co
            if (!src.includes('ghost.noissue.co')) {
                return match;
            };

            // Remove autogenerated srcset attributes since it does not work with CDN optimisation
            const updatedMatch = match.replace(/srcset="[^"]*"/g, '');
            
            // Replace the src with the CDN URL prepended
            return updatedMatch.replace(
                `src="${src}"`,
                `src="https://ghost.noissue.co/cdn-cgi/image/width=720,format=avif,quality=80/${src}" onError="this.onerror=null; this.src='${src}'"}`
            );
        });
    }

    render() {
        const { data, location } = this.props;
        const post = data.ghostPost;
        const postHtml = this.prependCdnToImages(post.html);

        return (
            <>
                <MetaData
                    data={data}
                    location={location}
                    type="article"
                />
                
                <Helmet>
                    <style type="text/css">{`${post.codeinjection_styles}`}</style>
                </Helmet>
                <Layout bodyClass={`post ${post.slug} elbrus-headless`}>
                    <div className="container">
                        <article className="content content-post">
                            <header className="row">
                                <div className="column">
                                    {post.feature_image ? (
                                        <figure className="post-feature-image">
                                            <img
                                                src={`https://ghost.noissue.co/cdn-cgi/image/width=700,format=avif,quality=90/${post.feature_image}`}
                                                alt={post.title}
                                                fetchPriority="high"
                                                onError={(e) => {
                                                    e.target.onerror = null; // Prevent infinite loop
                                                    e.target.src = post.feature_image;
                                                }}
                                            />
                                        </figure>
                                    ) : null}
                                </div>
                                <div className="column content-section">
                                    <h1 className="content-title">
                                        {post.title}
                                    </h1>
                                    <p>{post.custom_excerpt}</p>
                                    <p>
                                        By{" "}
                                        <a
                                            href={withPrefix(
                                                `/author/${post.primary_author.slug}`
                                            )}
                                        >
                                            {post.primary_author.name}
                                        </a>{" "}
                                        &mdash; {post.published_at_pretty}
                                    </p>
                                </div>
                            </header>
                            <section
                                id="post-body"
                                className="content-body load-external-scripts"
                                dangerouslySetInnerHTML={{
                                    __html: postHtml
                                }}
                            />
                            {/*createRelatedPostFeeds(posts, post)*/}
                        </article>
                    </div>
                </Layout>
            </>
        );
    }
}

Post.propTypes = {
    data: PropTypes.shape({
        ghostPost: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            html: PropTypes.string,
            feature_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
};

export default Post;

export const postQuery = graphql`
    query($slug: String!) {
        ghostPost(slug: { eq: $slug }) {
            ...GhostPostFields
        }
    }
`;
